import { INVOICES_INDEX_PATH } from "~/constants/appRoutes.ts";
import { ProjectDetailsTabName, ProjectReportingSubsection } from "~/modules/project/types/projectViewTypes.ts";
import { getProjectBillingPath, getProjectReportsPath } from "~/modules/project/utils/projectDetailsViewUtils.ts";

export const validInvoiceDetailsNavigatedFromOrigins = {
	PROCESSED_INVOICES_INDEX: "index",
	PROJECT_INVOICES: "project",
	PROJECT_REVENUE_REPORT: "project-revenue",
} as const;

export type ValidInvoiceDetailsNavigatedFromOrigin = typeof validInvoiceDetailsNavigatedFromOrigins[keyof typeof validInvoiceDetailsNavigatedFromOrigins];

export function getInvoiceDetailsBackPath(from?: ValidInvoiceDetailsNavigatedFromOrigin, projectId?: string): string {
	if (from === validInvoiceDetailsNavigatedFromOrigins.PROJECT_REVENUE_REPORT && projectId) {
		return getProjectReportsPath(projectId, ProjectReportingSubsection.Revenue);
	}

	if (from === validInvoiceDetailsNavigatedFromOrigins.PROJECT_INVOICES && projectId) {
		return getProjectBillingPath(projectId, ProjectDetailsTabName.Invoices);
	}

	return INVOICES_INDEX_PATH;
}
